import Home from "../page/Home";

const HomeSection = () => {
    return (
        <section
            id="home"
            data-section
            data-title="Home"
            aria-label="Home"
            className="relative w-full min-h-screen"
        >
            <Home />
        </section>
    );
};

export default HomeSection;
